import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Country } from './country-models';
import { AuthService } from '../auth/auth.service';
import { tap, filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  countries = new BehaviorSubject<Country[]>([]);

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/countr`;
    this._getCountryList();
  }

  getCountryList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Country>> {
    return this.httpClient.get<AutoTablePageableResponse<Country>>(`${this._baseURL}ies`, {
      params: params
    }).pipe(tap(rs => this._getCountryList()));
  }

  getCountriesTemporary(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Country>> {
    return this.httpClient.get<AutoTablePageableResponse<Country>>(`${this._baseURL}ies`, {
      params: params
    });
  }

  newCountry(country: Country): Observable<any> {
    return this.httpClient.post(`${this._baseURL}y`, country);
  }

  updateCountry(country: Country): Observable<any> {
    return this.httpClient.put(`${this._baseURL}y/${country.code}`, country);
  }

  removeCountries(code: string | string[]): Observable<any> {
    if (!_.isArray(code)) {
      return this.httpClient.delete(`${this._baseURL}y/${code}`);
    } else {
      return this.httpClient.delete(`${this._baseURL}y`, {
        params: {
          code: code
        }
      });
    }
  }

  private _getCountryList() {
    this.httpClient.get<AutoTablePageableResponse<Country>>(`${this._baseURL}ies`, { params: { pageSize: '9999' } }).subscribe(cs => {
      const countries = cs.pageItems.filter(it => it.code !== '0');
      countries.forEach(c => c.number = '+' + c.number);
      this.countries.next(countries.sort((a, b) => a.name.localeCompare(b.name)));
    });
  }
}
